import editorialPanel from '../../../assets/images/marketplace/art/editorial-panel.webp';
import emptyMarketplaceCampaigns from '../../../assets/images/marketplace/art/empty-marketplace-campaigns.webp';
import facetPromoCategories from '../../../assets/images/marketplace/art/facet-promo-categories.webp';
import facetPromoFormat from '../../../assets/images/marketplace/art/facet-promo-format.webp';
import facetPromoPlatforms from '../../../assets/images/marketplace/art/facet-promo-platforms.webp';

/** Shared marketplace editorial art (transparent WebP). Categories stay in marketplaceCategoryIcons. */
const MARKETPLACE_ART = {
  editorialPanel,
  emptyMarketplaceCampaigns,
  facetPromoCategories,
  facetPromoFormat,
  facetPromoPlatforms,
};

export { MARKETPLACE_ART };
export default MARKETPLACE_ART;
